import React, { useEffect, useState } from "react";
import "./label.scss";
import Headernav from "../header_nav/Headernav";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
  Box,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { API_BASE } from "../apiBase";

const Label_print = () => {
  const [jsdata, setJsData] = useState([]);
  const [cityCheck, setCityCheck] = useState(false);
  const [selectedValue, setSelectedValue] = useState("option1");
  const [cityData, setCityData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [lifeStatusFilter, setLifeStatusFilter] = useState("all");

  const printbtn = () => {
    window.print();
  };

  const fetchData = async (selection, status, cityName) => {
    let url = "";

    if (selection === "option1") {
      url = `${API_BASE}/hello_wel86768767come_eac87356h_and_98676256every_member_profile_.php?status=${status}`;
    } else if (selection === "option2") {
      url = `${API_BASE}/ubyuy_873rg6t776fgyfw63rb7364rtn_wft73f-38wyd7w3gnf3fiwnf3y77knikjgsndfyv.php?status=${status}`;
    } else if (selection === "option3" && cityName) {
      url = `${API_BASE}/ys5d6b6sd5v7ew6rv3_rt36n87ntf863b3tf-Get_sdhufmjdbf-City_79f7y943selectedsidufng7et77.php?cityname=${encodeURIComponent(cityName)}&status=${status}`;
    }

    if (!url) {
      return;
    }

    try {
      const response = await axios.get(url);
      setJsData(response.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    setCityCheck(value === "option3");

    if (value !== "option3") {
      setInputValue("");
    } else {
      setJsData([]);
    }
  };

  const handleLifeStatusChange = (event) => {
    setLifeStatusFilter(event.target.value);
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${API_BASE}/78htc6w4_Get_sudyvgew7_City9879.php`);
        setCityData(response.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, []);

  useEffect(() => {
    if (selectedValue === "option3") {
      return;
    }

    fetchData(selectedValue, lifeStatusFilter);
  }, [selectedValue, lifeStatusFilter]);

  useEffect(() => {
    if (selectedValue !== "option3") {
      return;
    }

    if (!inputValue) {
      setJsData([]);
      return;
    }

    fetchData("option3", lifeStatusFilter, inputValue);
  }, [inputValue, lifeStatusFilter, selectedValue]);

  const groupedData = [];
  for (let i = 0; i < jsdata?.length; i += 2) {
    groupedData.push(jsdata.slice(i, i + 2));
  }

  return (
    <>
      <div>
        <div className="nav">
          <Headernav />

          <Box display="flex" justifyContent="center" alignItems="center" margin="2rem">
            <FormControl className="print_comp" component="fieldset">
              <Stack direction="row" spacing={2} alignItems="center">
                <FormControl size="small">
                  <InputLabel id="life-status-filter-label">நிலை</InputLabel>
                  <Select
                    labelId="life-status-filter-label"
                    value={lifeStatusFilter}
                    label="நிலை"
                    onChange={handleLifeStatusChange}
                  >
                    <MenuItem value="all">அனைத்தும்</MenuItem>
                    <MenuItem value="alive">செயலில் இருக்கிறார்</MenuItem>
                    <MenuItem value="removed">நீக்கப்பட்டார்</MenuItem>
                    <MenuItem value="expired">காலமானார்</MenuItem>
                  </Select>
                </FormControl>
                <RadioGroup
                  row
                  aria-label="data"
                  name="data"
                  value={selectedValue}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="option1" control={<Radio />} label="அனைவரும்" />
                  <FormControlLabel value="option2" control={<Radio />} label="நிர்வாக உறுப்பினர்கள்" />
                  <FormControlLabel value="option3" control={<Radio />} label="ஊர்" />
                </RadioGroup>
                <Button variant="contained" color="primary" onClick={printbtn}>
                  Print
                </Button>
              </Stack>
            </FormControl>
          </Box>

          {cityCheck && (
            <Box
              justifyContent="center"
              alignItems="center"
              width="80%"
              maxWidth="900px"
              margin="10px auto"
            >
              <Autocomplete
                options={cityData}
                getOptionLabel={(option) => option}
                value={inputValue}
                onChange={(event, newValue) => setInputValue(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select City"
                    variant="outlined"
                  />
                )}
                filterSelectedOptions
                freeSolo
              />
            </Box>
          )}

        </div>

        <div className="print-container">
          <div>
            <table className="data-table">
              <thead></thead>
              <tbody>
                {groupedData?.map((group, i) => (
                  group ?
                    <tr key={i}>
                      {group?.map((a, index) => (
                        <td key={index} className="table-cell">
                          {a.member_name} &nbsp;&nbsp;&nbsp;
                          <span className="member-id">{a.member_no}</span>  <br />
                          s/o {a.father_name} <br />
                          {a.house_name === "null" ? "" : a.house_name + ","}
                          {a.house_name === "null" ? "" : <br></br>}
                          {a.door_no === "null" ? "" : a.door_no + ","}{a.street},{a.area === "null" ? "" : <><br />{a.area + ","}</>} <br />{a.city}<br />
                          {a.district} -<span className="phone_font"> {a.pincode}</span><br />
                          Phone : &nbsp;<span className="phone_font">
                            {a.member_mobile}{a.member_alternative_mobile === "null" ? "" : "," + a.member_alternative_mobile}
                          </span><br />
                        </td>
                      ))}
                      {group?.length === 1 && <td className="table-cell"></td>}
                    </tr> : "No Data"
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Label_print;
